module.exports = __webpack_public_path__ + "assets/74ab4b31f6dd19f2180d4b17aa162e23.mp3";